var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.323193 8.72017C-0.10773 8.32243 -0.10773 7.67757 0.323193 7.27983L7.34549 0.798303C7.77642 0.400565 8.47508 0.400565 8.90601 0.798303C9.33693 1.19604 9.33693 1.8409 8.90601 2.23864L3.76741 6.98153L30.8966 6.98152C31.506 6.98152 32 7.43751 32 8C32 8.56248 31.506 9.01847 30.8966 9.01847L3.76741 9.01847L8.90601 13.7614C9.33693 14.1591 9.33693 14.804 8.90601 15.2017C8.47508 15.5994 7.77642 15.5994 7.3455 15.2017L0.323193 8.72017Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1C14 0.447715 14.4477 -3.91405e-08 15 -8.74228e-08L31 -1.48619e-06C31.5523 -1.53447e-06 32 0.447714 32 0.999998C32 1.55228 31.5523 2 31 2L15 2C14.4477 2 14 1.55228 14 1Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15C14 14.4477 14.4477 14 15 14L31 14C31.5523 14 32 14.4477 32 15C32 15.5523 31.5523 16 31 16L15 16C14.4477 16 14 15.5523 14 15Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamicon);
export default __webpack_public_path__ + "static/media/Hamicon.eb8a209e5c72e45d5c3345a613516249.svg";
export { ForwardRef as ReactComponent };